import { render, staticRenderFns } from "./FraudExcelContainer.vue?vue&type=template&id=0312fdac&scoped=true&"
import script from "./FraudExcelContainer.vue?vue&type=script&lang=ts&"
export * from "./FraudExcelContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0312fdac",
  null
  
)

export default component.exports